import {
  Show,
  SimpleShowLayout,
  TextField,
  ChipField,
  DateField,
  TopToolbar,
  ListButton,
  EditButton,
  CreateButton,
} from "react-admin";

const TagShowActions = ({ basePath, data, resource }) => (
  <TopToolbar>
    <ListButton basePath={basePath} />
    <CreateButton basePath={basePath} />
    <EditButton basePath={basePath} record={data} />
  </TopToolbar>
);

const TagShow = (props) => {
  return (
    <Show actions={<TagShowActions />} {...props}>
      <SimpleShowLayout>
        <TextField label="Id" source="id" />
        <ChipField source="title" color="primary" />
        <DateField
          source="created_at"
          label="Created At"
          showTime
          locales="fr-FR"
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default TagShow;
